export const PICKUP_MIN_HOURS_FROM_NOW = 1;

export const getPickupMinTime = (now: Date): Date =>
  new Date(now.getTime() + PICKUP_MIN_HOURS_FROM_NOW * 60 * 60 * 1000);

// Self-pickup can't be scheduled past 3am the day after `now`.
export const getPickupMaxTime = (now: Date): Date => {
  const d = new Date(now);
  d.setDate(d.getDate() + 1);
  d.setHours(3, 0, 0, 0);
  return d;
};
